import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import * as Sentry from '@sentry/react';
import App from './App';

Sentry.init({
  dsn: 'https://48bd0265fc904095a4035422d3bc4145@o83917.ingest.sentry.io/4504959207079936',
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 0.2
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename='/affiliate-area-dashboard'>
    <App />
  </BrowserRouter>
);
